module.exports = "pegasus_template/assets/background-patterns/wooden-wall.jpg";